"use client";

import { useSession, signOut } from "next-auth/react";
import { useEffect, useState } from "react";
import { usePathname } from 'next/navigation'
import { clientEnv } from "../../../env.client";

export default function UserAuthClientComponent() {
    const pathname = usePathname()
    const [callbackUrl, setCallbackUrl] = useState("");
    // SSR: Always render placeholder
    const [ui, setUi] = useState<React.ReactNode>(
        <div className="flex items-center gap-4 text-sm">
            <span className="text-white lg:text-black opacity-50">Loading…</span>
        </div>
    );

    useEffect(() => {
        setCallbackUrl(`${clientEnv.BASE_URL}${pathname}`);
    }, []);

    const { data: session, status } = useSession();

    useEffect(() => {
        if (status === "loading") {
            setUi(
                <div className="flex items-center gap-4 text-sm">
                    <span className="text-white lg:text-black opacity-50">Loading…</span>
                </div>
            );
        } else if (session?.user?.name) {
            setUi(
                <div className="flex flex-col lg:flex-row items-center gap-1 lg:gap-4 text-sm">
                    <div className="text-white lg:text-black">
                        Signed in as {session.user.name}
                    </div>
                    <button
                        type="button"
                        onClick={() => signOut()}
                        className="transition-colors hover:bg-white/10 text-[#D4A020] lg:text-[#967116] hover:text-[#D4A020] hover:cursor-pointer active:scale-95 active:text-[#ffcd4d]"
                    >
                        Sign Out
                    </button>
                </div>
            );
        } else {
            setUi(
                <a
                    rel="nofollow"
                    href={`/api/auth/signin?callbackUrl=${encodeURIComponent(callbackUrl)}`}
                    className="text-sm text-[#D4A020] lg:text-[#967116] hover:text-[#D4A020] hover:cursor-pointer active:scale-95 active:text-[#ffcd4d]"
                >
                    Employee Login
                </a>
            );
        }
    }, [session, status, callbackUrl]);

    return ui;
}